import { render, staticRenderFns } from "./ProfileButton.vue?vue&type=template&id=2859032b&scoped=true&"
import script from "./ProfileButton.vue?vue&type=script&lang=js&"
export * from "./ProfileButton.vue?vue&type=script&lang=js&"
import style0 from "./ProfileButton.vue?vue&type=style&index=0&id=2859032b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2859032b",
  null
  
)

export default component.exports